exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar[data-v-963808d8] {\n  width: 262px;\n}\n@media only screen and (max-width: 991px) {\n.sidebar[data-v-963808d8] {\n      display: none;\n}\n}\n", ""]);

// exports
